<html>

<head>
    <title>Ford Etis How to Help Page</title>
</head>

<body class="localhome">
    <div>
        <span class="close-span" (click)="closePage();"><u>{{this.translatedText[0]}} </u></span>&nbsp;
        <span class="print-span" (click)="printPage();"><u>{{this.translatedText[1]}} </u></span>  
    </div>
    <div class="sect">
        <h2 class="title1">{{this.translatedText[2]}}</h2>
        <p class="subject">{{this.translatedText[3]}}</p>
        <p class="subject">{{this.translatedText[4]}} <b>{{this.translatedText[5]}}</b> {{this.translatedText[6]}}</p>
        <p class="subject">{{this.translatedText[4]}} <b>{{this.translatedText[7]}}</b> {{this.translatedText[8]}}</p>
        <p class="subject">{{this.translatedText[4]}} <b>{{this.translatedText[9]}}</b> {{this.translatedText[10]}}</p>
        <p class="subject">{{this.translatedText[4]}} <b>{{this.translatedText[11]}}</b> {{this.translatedText[12]}}</p>
        <p class="subject">{{this.translatedText[4]}} <b>{{this.translatedText[13]}}</b> {{this.translatedText[14]}}</p>
        <p class="subject">{{this.translatedText[4]}} <b>RVC</b> {{this.translatedText[15]}}</p>
        <ul>
            <li><b>{{this.translatedText[16]}}</b> - {{this.translatedText[17]}}:-</li>
            <ul class="child">
                <li><b>RVC(A)</b> - {{this.translatedText[18]}}</li>
                <li><b>RVC(H)</b> - {{this.translatedText[19]}}</li>
                <li><b>RVC(T)</b> - {{this.translatedText[20]}}</li>
                <li><b>{{this.translatedText[43]}}</b> - {{this.translatedText[21]}}</li>
                <li><b>{{this.translatedText[44]}}</b> - {{this.translatedText[22]}}</li>
            </ul>
            <li>{{this.translatedText[23]}}</li>
            <li>{{this.translatedText[24]}}</li>
            <li><b>{{this.translatedText[25]}}</b> - {{this.translatedText[26]}}</li>
            <li><b>"{{this.translatedText[27]}}"</b> - {{this.translatedText[28]}}</li>
            <li><b>"{{this.translatedText[29]}}"</b> - {{this.translatedText[30]}}</li>
            <li><b>"{{this.translatedText[31]}}"</b> - {{this.translatedText[32]}}</li>
            <li><b>"{{this.translatedText[33]}}"</b> - {{this.translatedText[34]}}</li>
        </ul>
        <p class="subject">{{this.translatedText[4]}} <b>{{this.translatedText[35]}}</b> {{this.translatedText[36]}}</p>
        <ul>
            <li><img alt="" src="assets/images/automatic.jpg" border="0"> - {{this.translatedText[37]}}</li>
            <li><img alt="" src="assets/images/hotline.jpg"> - {{this.translatedText[38]}}</li>
            <li><img alt="" src="assets/images/technician.jpg"> - {{this.translatedText[39]}}</li>
            <li><img alt="" src="assets/images/norvc.jpg"> - {{this.translatedText[40]}}</li>
            <li><img alt="" src="assets/images/novcm.jpg"> - {{this.translatedText[41]}}</li>
            <li><img alt="" src="assets/images/novmm.jpg"> - {{this.translatedText[42]}}</li>
        </ul>
    </div>
    <div>
        <span class="close-span" (click)="closePage();"><u>{{this.translatedText[0]}} </u></span>&nbsp;
        <span class="print-span" (click)="printPage();"><u>{{this.translatedText[1]}} </u></span>  
    </div>
</body>

</html>